<template>
  <div class="st-mb">
    <!-- <st-social-button-group :colorTheme="colorTheme" :class="stSocialButtonGroupClass"></st-social-button-group> -->
    <!-- <template v-if="hasMenu"> -->
      <animated-burger :class="{'stDialogIsOpen': stDialogIsOpen}" :colorTheme="colorTheme" :open="stDialogIsOpen" @click.native="toggleMobileMenu"></animated-burger>
      <div :class="modalMenuClass">
        <div class="modal-menu-content-wrapper">
          <menu-panel-list />
          <ul>
            <li v-for="(item,i) in menu" :key="i" :class="{'current': isCurrentPage(item.href)}">
              <a v-if="item.module==='no'" :href="item.href" :title="item.title" :alt="item.title">{{item.name}}</a>
              <router-link v-else :title="item.title" @click.native="toggleMobileMenu" :to="item.href">{{item.name}}</router-link>
            </li>
          </ul>
        </div>
        <div class="close-dialog-panel" @click="openDialog = false"></div>
        <div class="st-content-shared-social">
          <!-- social buttons in modal are always dark theme -->
          <st-social-button-group colorTheme="dark" class="st-social-mobile"></st-social-button-group>
        </div>
      </div>
    <!-- </template> -->
  </div>
</template>

<script>
import {mapState} from 'vuex'
import StSocialButtonGroup from './StSocialButtonGroup.vue'
import AnimatedBurger from './AnimatedBurger.vue'
import MenuPanelList from './../..//artefacts/Project/MenuPanelList.vue'

export default {
  components: {StSocialButtonGroup, AnimatedBurger, MenuPanelList},
  props: ['colorTheme', 'hasMenu'],
  data () {
    return {
      openDialog: false
    }
  },
  watch: {
    stDialogIsOpen () {
      this.$blockScroll(this.stDialogIsOpen)
    }
  },
  computed: Object.assign(mapState(['menu', 'meta']), {
    stSocialButtonGroupClass () {
      return {
        'st-social-button-group': true,
        'hasMenu': this.hasMenu
      }
    },
    modalMenuClass () {
      return {
        'modal-menu-container': true,
        'stDialogIsOpen': this.stDialogIsOpen
      }
    },
    stDialogIsOpen () {
      // return this.$window.innerWidth < 768 && this.openDialog
      return this.openDialog
    }
  }),
  methods: {
    isCurrentPage (href) {
      const pageName = window.location.pathname.split('/').pop() || 'index.html'
      return pageName === href.trim()
    },
    toggleMobileMenu () {
      this.openDialog = !this.openDialog
    },
    onRouteChange (done) {
      if (this.stDialogIsOpen) this.toggleMobileMenu()
      done()
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      this.onRouteChange(next)
    })
  }
}
</script>

<style lang="scss">
.st-mb {
  .st-button-menu-mobile {
    position: fixed;
    z-index: 99999;
    right: 5px;
    top: 4px;
    cursor: pointer;
    line-height: 1;

    @media (min-width:1440px) {
      margin-right: calc((100vw - 1440px) / 2);
      transition: margin-right 0.3s ease-in-out;
      &.stDialogIsOpen {
        margin-right: 0;
      }
    }

    @include breakpoint($d_menu_mobile) {
      // display: none;
      top: 6px;
      
      svg {
        width: 38px;
        height: 38px;
      }
    }
    
  }

  .modal-menu-container {
    position: fixed;
    z-index: 9999;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: hidden;
    opacity: 0;
    transform: translateX(100%);
    transition: opacity 0.5s, transform 0.5s, background-color 0s;

    &.stDialogIsOpen {
      transition: opacity 0.5s, transform 0.5s, background-color 0.5s 0.5s;
      opacity: 1;
      transform: translateX(0%);
      pointer-events: auto;
      background-color: rgba(#000000, 0.5);
    }

    .modal-menu-content-wrapper {
      position: absolute;
      right: 0;
      width: 80%;
      height: 100%;
      max-width: 420px;
      box-sizing: border-box;
      background-color: #FFFFFF;
      padding: 40px 0 40px;
      overflow: auto;
      -webkit-overflow-scrolling: 'touch';

      @media (max-width: $d_menu_mobile) {
        width: 100%;
      }
      
      ul {
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        padding: 0 13px 45px;

        li {
          opacity: 0.6;
          border-bottom: 1px solid $greydark;
          padding: 5px 0;

          &:first-of-type {
            padding-top: 0;
          }

          &.current {
            opacity: 1;

            a {
              cursor: default;
            }
          }

          a {
            font-family: $font-CuratorRegular;
            font-size: 16px;
            color: $black;
            line-height: 1.5;
            letter-spacing: 1px;
            border-bottom: none;
            text-transform: uppercase;
            cursor: pointer;
            white-space: normal;
          }
        }
      }
    }

    .close-dialog-panel {
      position: absolute;
      top: 0;
      left: 0;
      width: 20%;
      height: 100%;
    }

    .st-content-shared-social {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 80%;
      max-width: 420px;
      padding: 7px 10px;
      background-color: #FFFFFF;
      box-sizing: border-box;
      @media (max-width: $d_menu_mobile) {
        width: 100%;
      }
      & > * {
        float: right;
      }
    }
  }

  .st-social-button-group {
    display: inline-block;
    margin-right: 25px;

    @include breakpoint($d_menu_mobile) {
      margin-right: 38px;
    }
    @media (min-width:1440px) {
      margin-right: 48px;
    }

    &.hasMenu {
      display: none;

      @include breakpoint($d_menu_mobile) {
        display: inline-block;
      }
    }
  }
} // st-mb
</style>
